import { ApplicationsTabbedListingPage } from 'pages';

export const ApplicationsPageWrapper = () => {
  return <ApplicationsTabbedListingPage />;
};
